import OldAffiliateLayout from "@components/layouts/Affiliate";
import Disclaimer from "@components/layouts/Affiliate/Disclaimer";
import InformationCard from "@components/layouts/Affiliate/InformationCard";
import OffersCard from "@components/layouts/Affiliate/OffersCard";
import ProductCard from "@components/layouts/Affiliate/ProductCard";
import ProductPresentation from "@components/layouts/Affiliate/ProductPresentationCard";
import RulesCard from "@components/layouts/Affiliate/RulesCard";
import Loader from "@components/layouts/Loader";
import PageTitle from "@components/layouts/PageTitle";
import { AffiliateProvider } from "@contexts/affiliate/AffiliateContext";
import { useAffiliateData } from "@hooks/affiliates/affiliate/useAffiliateData";
import Custom404 from "@pages/404";
import { ReactNode } from "react";

export default function Affiliate() {
  const { data, isLoading } = useAffiliateData();

  if (isLoading) return <Loader loading={isLoading} />;

  if (!data) return <Custom404 />;

  const affiliatesEnabled = data?.affiliatesEnabled;

  return (
    <>
      <AffiliateProvider>
        <PageTitle title="Afiliados" />
        <ProductPresentation>
          <ProductCard />
        </ProductPresentation>
        {affiliatesEnabled && <Disclaimer />}
        <InformationCard />
        {affiliatesEnabled && (
          <>
            <OffersCard />
            <RulesCard />
          </>
        )}
      </AffiliateProvider>
    </>
  );
}

Affiliate.getLayout = function getLayout(page: ReactNode) {
  return <OldAffiliateLayout>{page}</OldAffiliateLayout>;
};
